import { Modal } from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import PlannerBlock from "layout/proposals/outline/gates/PlannerBlock";
import { func } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import {
  selectClarification,
  selectClarificationAnswers,
} from "slices/proposalOutline/selectors";

import styles from "./OutlineClarificationModal.module.scss";

const TITLE = "I Need A Quick Check";

const OutlineClarificationModal = ({ onSubmit }) => {
  const dispatch = useDispatch();
  const block = useSelector(selectClarification);
  const priorAnswers = useSelector(selectClarificationAnswers);

  if (!block) {
    return null;
  }

  const dismiss = () => {
    // Only hide the modal — do NOT clear the clarification block or the accumulated
    // answers. The block is cleared on completion via handleCompletedEvent, and the
    // paused banner is status-gated, so nothing lingers after completion. Wiping here
    // would break the recovery chain: the banner's "Answer Questions" would reopen a
    // modal that renders null (block gone) and lose the user's answers.
    dispatch(hideModal(modalTypes.CLARIFICATION_REQUIRED));
  };

  const submit = (answers) => {
    onSubmit(answers);
    dismiss();
  };

  return (
    <Modal show onDismiss={dismiss} className={styles.modal} backdrop>
      <Modal.Header>{TITLE}</Modal.Header>
      <Modal.Body>
        <div className={styles.header}>
          <span className={styles.badge}>?</span>
        </div>

        <PlannerBlock
          block={block}
          priorAnswers={priorAnswers}
          onSubmit={submit}
        />
      </Modal.Body>
    </Modal>
  );
};

OutlineClarificationModal.propTypes = {
  onSubmit: func.isRequired,
};

export default OutlineClarificationModal;
